import React, { memo, useContext, useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { message } from '@tencent/tea-component';
import GradientDescDialog from '@tencent/tpm-meeting-active/lib/GradientDescDialog';
import '@tencent/tpm-meeting-active/lib/GradientDescDialog/style';
import { useStore } from '@utils/event-store/useEventData';
import DashboardCommonGetResourceData from 'src/quick-services/DashboardCommonGetResourceData';
import { AppContext } from '@utils/browser/app-context';
import dayjs from 'dayjs';

interface ResourceListItem {
  /**
   * 会员名字，如个人免费版
   */
  member_type_name: string;
  /**
   * 包含的所有能力
   */
  data_list: {
    /**
     * 方数
     */
    audience_number: number;
    /**
     * 日常时间限制（秒），-1表示永久
     */
    duration_limit: number;
    /**
     * 会场类型
     */
    venue_type: number;
  }[];
}

interface TableProps {
  visible: boolean;
  setVisible: Function;
}

const GradientDescDialogTable: React.FC<TableProps> = ({ visible, setVisible }) => {
  const router = useRouter();
  const { query } = router;
  const eventId = String(query.eventid);
  // const [visible, setVisible] = useState(false);
  // 梯度回收表格数据
  const [resourceList, setResourceList] = useState<ResourceListItem[]>([]);
  // 会员过期时间
  const [memberExpireTime, setMemberExpireTime] = useState(0);
  const { userData } = useContext(AppContext);
  const { eventInfo, userAuthority, hostDetail } = useStore();
  const isCreated = userAuthority?.org_role_id === 1;
  useEffect(() => {
    // 用户为个人版账号时才调用，企业账号/商业账号无法获取版本信息
    if (userData?.user_type === '1') {
      // 获取梯度回收表格数据
      DashboardCommonGetResourceData({
        event_id: eventId,
      }).then(
        (res) => {
          setResourceList(res.data?.resource_list || []);
          setMemberExpireTime(res.data?.member_expire_time);
        },
        (err) => {
          message.error({
            content: err,
          });
        },
      );
    }
  }, [userData]);

  return (
    <GradientDescDialog
      title="开通腾讯会议会员"
      tableTitle="版本功能对比"
      tableDesc="您购买的腾讯会议会员版本决定了你场地的容纳人数和时间限制，详情如下："
      visible={visible}
      onClose={() => {
        setVisible(false);
      }}
      info={{
        name: <span>{hostDetail?.host_name || eventInfo?.host_name || ''}</span>,
        deadline: (
          <span>
            {memberExpireTime !== -1 ? (
              <span>有效期至 {dayjs(memberExpireTime * 1000).format('YYYY/MM/DD')}</span>
            ) : (
              ''
            )}
          </span>
        ),
        vip: memberExpireTime !== -1,
        // @ts-ignore
        img: hostDetail?.host_avatar_url,
        detailsLink: {
          text: isCreated ? '查看详情' : '',
          onClick: () => {
            // 用户是主办方创建者的话，就跳转；不是的话仅关闭弹窗
            if (isCreated) {
              window.open(
                `${window.location.origin}/buy.html?web.hd.hdtc.hyhd&version=personal&open-vip=1`,
              );
            }
          },
        },
      }}
      tableData={{
        header: [
          {
            value: '',
            // width: '145px',
            width: '22%',
          },
          {
            value: '活动梯度',
            icon: 'active',
            // width: '185px',
            width: '29%',
          },
          {
            value: '网络研讨会',
            // width: '170px',
            width: '26%',
          },
          {
            value: '云会议',
            // width: '142px',
            width: '23%',
          },
        ],
        records: resourceList?.map((item) => ({
          name: item.member_type_name,
          grad: [
            {
              value: (
                <>
                  <div>
                    {item.data_list.length === 2 && (
                      <div>
                        {/* <span>大型会场</span> {item.data_list[2]?.audience_number}方
                        {item.data_list[2]?.duration_limit === 3600 ? '(60分钟)' : '(不限时)'} */}
                        <span>大型会场</span> {item.data_list[0]?.audience_number}方 {'(不限时)'}
                      </div>
                    )}
                    {item.data_list.length === 4 && (
                      <div>
                        {/* <span>大型会场</span> {item.data_list[2]?.audience_number}方
                        {item.data_list[2]?.duration_limit === 3600 ? '(60分钟)' : '(不限时)'} */}
                        <span>大型会场</span> {item.data_list[2]?.audience_number}方 {'(不限时)'}
                      </div>
                    )}
                  </div>
                  {/* {item.data_list.length === 4 && <div className="item-line">-</div>} */}
                  {/* <span>大型会场</span> {item.data_list[0]?.audience_number}方
                    {item.data_list[0]?.duration_limit === 3600 ? '(60分钟)' : '(不限时)'} */}
                  {/* <span>大型会场</span> {item.data_list[0]?.audience_number}方 {'(不限时)'} */}
                </>
              ),
            },
            {
              value: (
                <>
                  <div>
                    {item.data_list.length === 2 && (
                      <div>
                        {/* <span>小型讨论室</span> {item.data_list[3]?.audience_number}方
                        {item.data_list[3]?.duration_limit === 3600 ? '(60分钟)' : '(不限时)'} */}
                        <span>小型讨论室</span> {item.data_list[1]?.audience_number}方 {'(不限时)'}
                      </div>
                    )}
                    {item.data_list.length === 4 && (
                      <div>
                        {/* <span>小型讨论室</span> {item.data_list[3]?.audience_number}方
                        {item.data_list[3]?.duration_limit === 3600 ? '(60分钟)' : '(不限时)'} */}
                        <span>小型讨论室</span> {item.data_list[3]?.audience_number}方 {'(不限时)'}
                      </div>
                    )}
                  </div>
                  {/* <span>小型讨论室</span> {item.data_list[1]?.audience_number}方
                    {item.data_list[1]?.duration_limit === 3600 ? '(60分钟)' : '(不限时)'} */}
                  {/* <span>小型讨论室</span> {item.data_list[1]?.audience_number}方 {'(不限时)'} */}
                </>
              ),
            },
          ],
          webinar: (
            <>
              {/* {item.data_list.length === 2 && `${item.data_list[0]?.audience_number}方
                ${item.data_list[0]?.duration_limit === 3600 ? '(60分钟)' : '(不限时)'}`} */}
              {item.data_list.length === 2 && `${item.data_list[0]?.audience_number}方 (不限时)`}
              {item.data_list.length === 4 &&
                `${item.data_list[2]?.audience_number}方 ${
                  item.data_list[2]?.duration_limit === 3600 ? '(60分钟)' : '(不限时)'
                }`}
            </>
          ),
          meeting: (
            <>
              {/* {item.data_list.length === 2 && `${item.data_list[1]?.audience_number}方
                ${item.data_list[1]?.duration_limit === 3600 ? '(60分钟)' : '(不限时)'}`} */}
              {item.data_list.length === 2 && `${item.data_list[1]?.audience_number}方 (不限时)`}
              {item.data_list.length === 4 &&
                `${item.data_list[3]?.audience_number}方 ${
                  item.data_list[3]?.duration_limit === 3600 ? '(60分钟)' : '(不限时)'
                }`}
            </>
          ),
        })),
      }}
      btn={{
        text: isCreated ? '前往选购' : '联系创建者升级',
        onClick: () => {
          // 用户是主办方创建者的话，就跳转；不是的话仅关闭弹窗
          if (isCreated) {
            window.open(
              `${window.location.origin}/buy.html?web.hd.hdtc.hyhd&version=personal&open-vip=1`,
            );
          }
          setVisible(false);
        },
      }}
    />
  );
};

export default memo(GradientDescDialogTable);
